import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { useOwnedBundleForProduct } from '../inventory/useProductInventory';
const getValidatedBundleBadgeKey = bundleProduct => {
  if (!(bundleProduct !== null && bundleProduct !== void 0 && bundleProduct.productApiName)) {
    return null;
  }
  const key = `pricing-pages-ui.merchCardsV2.badges.OWNED_VIA_BUNDLE.${bundleProduct.productApiName}`;
  if (isValidI18nKey(key)) {
    return key;
  }
  console.warn(`Invalid translation key for bundle: ${key}`);
  return null;
};

/**
 * Determines the appropriate badge for a single product based on priority:
 * Most popular → Trials → Provided badge name
 *
 * @param productApiName - The API name of the product
 * @param badgeName - Optional badge name to show if no higher priority badges apply
 * @returns Badge information and loading states
 * @returns badgeName - The determined badge name to display
 * @returns validatedBundleKey - Validated i18n key for bundle badges
 * @returns loading - Bundle loading state
 */
export const useCardBadge = ({
  apiName,
  badgeName
}) => {
  const {
    bundleProduct: ownedBundleProduct,
    loading: bundleLoading
  } = useOwnedBundleForProduct({
    apiName
  });
  let validatedBundleKey = null;
  if (badgeName === 'OWNED_VIA_BUNDLE') {
    validatedBundleKey = getValidatedBundleBadgeKey(ownedBundleProduct);
    if (!validatedBundleKey) {
      badgeName = 'CURRENT_PLAN';
    }
  }
  return {
    badgeName,
    validatedBundleKey,
    loading: bundleLoading
  };
};